<div class="denomination-container">
  <div class="denomination body-2">
    {{ fileInfo.label }}
    @if (isCoInvestisseur) {
      <span> - co-investisseur</span>
    }
  </div>
</div>
<div class="file-name-container">
  @if (!isFileLoading) {
    @if (fileInfo.missingState === 'notMissing') {
      <div class="file-name caption">
        {{ fileInfo.fileName }}
        @if (outdatedDocument) {
          <div class="outdated-document-alert">
            <span>Un document signé plus récent du même type existe</span>
            <button
              type="button"
              class="oui-link update-link"
              (click)="$event.stopPropagation(); refreshOutdatedDocument.emit($event)">
              Mettre à jour
            </button>
          </div>
        }
      </div>
    }
    @if (!(fileInfo.missingState === 'notMissing')) {
      <div class="uploader-group">
        <oui-file-uploader
          #uploader="ouiFileUploader"
          type="tiny"
          accept=".pdf,.jpg,.jpeg,.png"
          (valueChange)="onFilesChange($event)"
          [maxFileSize]="20">
          Glisser déposer ou ajouter <br />
          <span class="oui-link body-2" (click)="openPicker(uploader)"> depuis mon ordinateur </span>
        </oui-file-uploader>
        <oui-button class="investor-link" iconPrefix="backup" type="text" (click)="addFromInvestisseurDocs.emit()">
          Ajouter depuis les documents investisseur
        </oui-button>
      </div>
    }
  }
  @if (isFileLoading) {
    <oui-loading size="small"></oui-loading>
  }
</div>
<div class="status-container">
  @if (!fileInfo.isUploading) {
    @if (fileInfo.missingState === 'notMissing') {
      <oui-tag type="status" status="completed" size="big">Ajouté</oui-tag>
    }
    @if (fileInfo.missingState === 'mandatory') {
      <oui-tag type="status" status="to-correct" size="big"
        >Manquant</oui-tag
        >
      }
      @if (fileInfo.missingState === 'facultative') {
        <oui-tag type="status" status="pending" size="big"
          >Facultatif</oui-tag
          >
        }
      }
      @if (fileInfo.isUploading) {
        <oui-loading size="small"></oui-loading>
      }
    </div>
